import { Paddle } from '../entities/Paddle';
import { Ball } from '../entities/Ball';
import { PowerUp } from '../entities/PowerUp';
import { BlackHole } from '../entities/BlackHole';

export type GamePhase = 'MENU' | 'COUNTDOWN' | 'PLAYING' | 'GAME_OVER';

export class GameState {
  phase: GamePhase = 'MENU';
  score: number = 0;
  sessionTopScore: number = 0;
  initialPlayerCount: number = 8;
  frameCounter: number = 0;

  paddles: Paddle[] = [];
  balls: Ball[] = [];
  powerups: PowerUp[] = [];
  blackHole: BlackHole = new BlackHole();

  isCountingDown: boolean = false;
  countdownValue: number = 0;
  canvasMessage: string = '';
  hasShownHighScoreBanner: boolean = false;

  reset(playerCount: number): void {
    this.phase = 'COUNTDOWN';
    this.score = 0;
    this.initialPlayerCount = playerCount;
    this.frameCounter = 0;
    this.paddles = [];
    this.balls = [];
    this.powerups = [];
    this.blackHole = new BlackHole();
    this.isCountingDown = false;
    this.countdownValue = 0;
    this.canvasMessage = '';
    this.hasShownHighScoreBanner = false;
  }

  get humanPlayer(): Paddle | undefined {
    return this.paddles.find(p => p.isHuman);
  }

  get activeBots(): Paddle[] {
    return this.paddles.filter(p => !p.isHuman && !p.isWall && p.isAlive);
  }

  get activeCombatants(): Paddle[] {
    return this.paddles.filter(p => !p.isWall && p.isAlive);
  }
}
